import socialApiClient from "../../helpers/services/social-api-client";
import {
  SocialWallAccount,
  SocialWallExternalResult,
  SocialWallPost,
  SocialWallProvider,
} from "../interfaces";

interface AccountsResponse {
  message: string;
  payload: { accounts: SocialWallAccount[] };
}

interface FeedResponse {
  message: string;
  payload: {
    provider: string;
    posts: SocialWallPost[];
    total: number;
    fetchedAt: string;
  };
}

interface ExternalSearchResponse {
  message: string;
  payload: { results: SocialWallExternalResult[] };
}

export const socialWallApiService = {
  getAccounts(companyId: string) {
    return socialApiClient()
      .get<AccountsResponse>(`social/wall/accounts`, {
        params: { companyId },
      })
      .then(({ data }) => data.payload.accounts || []);
  },

  getFeed(
    companyId: string,
    params: {
      provider: SocialWallProvider | string;
      limit?: number;
      q?: string;
      mediaType?: string;
      streamType?: string;
      externalId?: string;
      externalUsername?: string;
    }
  ) {
    return socialApiClient()
      .get<FeedResponse>(`social/wall/feed`, {
        params: { companyId, ...params },
      })
      .then(({ data }) => data.payload);
  },

  searchExternal(
    companyId: string,
    params: { provider: SocialWallProvider | string; q: string }
  ) {
    return socialApiClient()
      .get<ExternalSearchResponse>(`social/wall/external/search`, {
        params: { companyId, ...params },
      })
      .then(({ data }) => data.payload.results || []);
  },

  deletePost(
    companyId: string,
    params: { provider: SocialWallProvider | string; postId: string }
  ) {
    return socialApiClient()
      .delete<{ message: string; payload: { deleted: boolean; postId: string } }>(
        `social/wall/post`,
        {
          // CompanyMemberMiddleware only reads companyId from query
          params: { companyId },
          data: { ...params },
        }
      )
      .then(({ data }) => data.payload);
  },
};
